import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Edit as Pen, Delete as Trash, Restore } from "@material-ui/icons";
import { Grid, Button, Typography, withStyles } from "@material-ui/core";

import RestoreEmployeesModal from "app/components/modals/employee/show-restore-employees-modal";
import Pagination from "app/components/pagination/Pagination";
import Searcher from "app/components/searcher/Searcher";
import CobeeSelect from "app/components/cobeeSelect/CobeeSelect";

import {
  SplitTreatments,
  withSplitFactory,
} from "@splitsoftware/splitio-react";
import { displayActiveEmployees } from "../../displays/display-active-employees";
import { displayEmployeeFilters } from "../../displays/display-employees-filters";
import { displayEditEmployeesCsvPage } from "../../displays/display-edit-employees-csv-page";
import { sendEmployeeBulkSession } from "../../send-employees-bulk-session";
import { changeBenefitModel } from "../../update-benefit-model";
import { changeTaxRegime } from "../../update-tax-regime";
import { toggleEmployees } from "../../toggle-employees";

import { selectAllEmployees } from "../../select-employees";
import { searchActiveEmployees } from "../../search-active-employee";
import { translate as t } from "../../../../infrastructure/translate/localization";

import ActiveEmployeeTable from "../ActiveEmployeeTable";
import reviewEmployeesToDelete from "../../review-employees-to-delete";
import styles from "./styles";
import featureFlagsDictionary from "../../../../infrastructure/split/feature-flags-dictionary";
import sdkConfig from "../../../../infrastructure/split/sdkConfig";
import { showErrorMessage } from "../../../commons/show-error-message";
import { findCompanyId } from "../../../../infrastructure/repository/company-repository";

class ActiveEmployees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricingType: localStorage.getItem("pricing_type"),
      showRestoreModal: false,
    };
  }

  componentDidMount() {
    displayEmployeeFilters();
  }

  changeMassiveModel = (modelId) => {
    const { selected, currentFilters, currentEmployees } = this.props;

    const employeesToMove = currentEmployees
      .filter(
        (employee) =>
          employee.modelId !== modelId && selected.includes(employee.id)
      )
      .map(({ id }) => id);

    if (employeesToMove.length !== 0) {
      changeBenefitModel(
        currentEmployees
          .filter(
            (employee) =>
              employee.modelId !== modelId && selected.includes(employee.id)
          )
          .map(({ id }) => id),
        modelId,
        currentFilters
      );
    } else {
      showErrorMessage(
        t("employees-section.employees-cant-be-on-same-employee-group")
      );
    }
  };

  changeMassiveTaxRegime = (taxRegime) => {
    const { selected } = this.props;
    changeTaxRegime({ employeeIds: selected, taxRegime });
  };

  toggleMassiveActive = (value) => {
    const { selected } = this.props;
    toggleEmployees({ employeeIds: selected, activate: value });
  };

  handleEditMassive = async () => {
    const { selected, currentEmployees } = this.props;
    await sendEmployeeBulkSession(selected);
    const selectedEmployees = [];
    selected.map((id) => {
      const employee = currentEmployees.find((emp) => emp.id === id);
      return selectedEmployees.push(employee);
    });
    displayEditEmployeesCsvPage({ selectedEmployees });
  };

  render() {
    const {
      currentEmployees,
      employees,
      currentPage,
      pageCount,
      selected,
      employeeIds,
      currentFilters,
      taxRegimes,
      benefitModels,
      classes: { button, select, selectContainer, toolbarContainer },
    } = this.props;

    const { value, search, pricingType, showRestoreModal } = this.state;

    const employeesSelected = currentEmployees.filter((e) =>
      selected.includes(e.id)
    );

    const showButtons = employeesSelected.every((e) => {
      return e.state !== "removed" && e.state !== "moved" && !e.inMigration;
    });

    const isEmployeeRemoved = employeesSelected.every((e) => {
      return e.state === "removed";
    });

    const companyId = findCompanyId();

    return (
      <>
        <Searcher
          buttonText={t("actions.search")}
          value={search}
          handledChange={(e) => searchActiveEmployees(e.target.value)}
        />
        <div id="filters-employees-container" />
        <Grid
          item
          container
          xs={12}
          alignItems="center"
          justify="flex-start"
          className={toolbarContainer}
        >
          <div
            className="cob-checkbox"
            onClick={() =>
              selectAllEmployees({
                ids: employeeIds,
                cb: () =>
                  displayActiveEmployees({
                    currentPage,
                    employeeFilter: currentFilters,
                  }),
              })
            }
            role="presentation"
          >
            {(selected.length > 0 && selected.length === employeeIds.length && (
              <FontAwesomeIcon icon="check" />
            )) ||
              (selected.length > 0 && <FontAwesomeIcon icon="minus" />)}
          </div>
          <h3>{`${t("employees-section.all-employees")} (${
            employeeIds.length
          })`}</h3>

          {selected.length !== 0 && (
            <div className={selectContainer}>
              <CobeeSelect
                styleContainer={`adjust-content ${select}`}
                handledChange={(e) =>
                  this.changeMassiveTaxRegime(e.target.value)
                }
                value={value}
                listItems={taxRegimes}
                placeholder={t("employees-section.tax-regime")}
              />
              <SplitTreatments
                names={[featureFlagsDictionary.BT_10]}
                attributes={{ companyId }}
              >
                {({ treatments, isReady }) => {
                  if (
                    isReady &&
                    treatments[featureFlagsDictionary.BT_10].treatment !== "on"
                  ) {
                    return (
                      <CobeeSelect
                        styleContainer={`adjust-content ${select}`}
                        handledChange={(e) =>
                          this.changeMassiveModel(e.target.value)
                        }
                        placeholder={t("employees-section.select-model")}
                        value={value}
                        listItems={benefitModels}
                      />
                    );
                  }
                  return <></>;
                }}
              </SplitTreatments>

              {showButtons && (
                <CobeeSelect
                  styleContainer={`adjust-content ${select}`}
                  handledChange={(e) =>
                    this.toggleMassiveActive(parseInt(e.target.value, 10))
                  }
                  placeholder={`${t("actions.enable")}/${t(
                    "actions.disable"
                  )} `}
                  value={value}
                  listItems={[
                    { name: t("actions.enable"), id: 1 },
                    { name: t("actions.disable"), id: 0 },
                  ]}
                />
              )}

              {showButtons && (
                <Button
                  onClick={this.handleEditMassive}
                  size="small"
                  disableRipple
                  className={button}
                >
                  <Pen />
                  <Typography variant="body2">{t("actions.edit")}</Typography>
                </Button>
              )}

              {showButtons && (
                <Button
                  onClick={() =>
                    reviewEmployeesToDelete({ employees: selected })
                  }
                  size="small"
                  disableRipple
                  className={button}
                >
                  <Trash />
                  <Typography variant="body2">{t("actions.delete")}</Typography>
                </Button>
              )}

              {isEmployeeRemoved && (
                <Button
                  onClick={() =>
                    this.setState((prevState) => ({
                      ...prevState,
                      showRestoreModal: true,
                    }))
                  }
                  size="small"
                  disableRipple
                  className={button}
                >
                  <Restore />
                  <Typography variant="body2">
                    {t("actions.restore")}
                  </Typography>
                </Button>
              )}
            </div>
          )}
        </Grid>
        <ActiveEmployeeTable
          isFreemium={pricingType === "freemium"}
          employees={employees}
          currentFilters={currentFilters}
          currentPage={currentPage}
          selected={selected}
        />
        <Pagination
          pages={pageCount}
          current={currentPage}
          prev={() =>
            displayActiveEmployees({
              currentPage: currentPage - 1,
              employeeFilter: currentFilters,
            })
          }
          next={() =>
            displayActiveEmployees({
              currentPage: currentPage + 1,
              employeeFilter: currentFilters,
            })
          }
        />
        <RestoreEmployeesModal
          employeesIds={selected}
          isOpen={showRestoreModal}
          setIsOpen={(_value) =>
            this.setState((prevState) => ({
              ...prevState,
              showRestoreModal: _value,
            }))
          }
        />
      </>
    );
  }
}

ActiveEmployees.defaultProps = {};

ActiveEmployees.propTypes = {
  employees: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  selected: PropTypes.array.isRequired,
  employeeIds: PropTypes.array.isRequired,
  currentFilters: PropTypes.func.isRequired,
  taxRegimes: PropTypes.array.isRequired,
  benefitModels: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  currentEmployees: PropTypes.array.isRequired,
};

export default withStyles(styles)(withSplitFactory(sdkConfig)(ActiveEmployees));
